import React, { useState } from "react";
import Button from "../Button/Button";
import "./OpenDoorCard.css";
import { IoSwapHorizontalOutline } from "react-icons/io5";
import ModalComponent from "../Modal/ModalComponent";
import ListCondoUsers from "../../views/CondoUsers/ListCondoUsers/ListCondoUsers";
import Input from "../Input/Input";
import Spacer from "../Spacer/Spacer";
import { useListManager } from "../../contexts/list.manager";
import { useUserStore } from "../../contexts/userStore";

const OpenDoorCard = (props) => {
  const [showModalDefineUser, setShowModalDefineUser] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [filters, setFilters] = useState([""]);
  const [userSelected, setUserSelected] = useState();
  const { lineSelected } = useListManager();
  const { selectedCondominioObj } = useUserStore();

  const handleOpenDoor = () => {
    setUserSelected(null);
  };
  const handleConfirm = () => {
    setUserSelected(lineSelected);
    setShowModalDefineUser(false);
  };
  const handleCancel = () => {
    setShowModalDefineUser(false);
  };
  return (
    <div className="open-doors-container">
      <div style={{ display: "flex", alignItems: "center" }}>
        <IoSwapHorizontalOutline size={20} color={"#3D4D59"} />
        <h1 className="open-door-title">{props.access?.name}</h1>
      </div>
      <div style={{ color: "#0C86C6" }}>
        {userSelected?.name ? "Abrir para: " + userSelected.name : ""}
      </div>
      <div className="open-doors-buttons-container">
        <Button
          className={"button-blue open-doors-buttons"}
          label={"Abrir Porta"}
          onClick={handleOpenDoor}
        />
        {selectedCondominioObj.inform_user_on_enter && (
          <Button
            className={"button-white open-doors-buttons"}
            label={"Vincular Usuário"}
            onClick={() => setShowModalDefineUser(true)}
          />
        )}
      </div>
      <ModalComponent
        modalIsOpen={showModalDefineUser}
        modalText={"Escolha um usuário para acessar:"}
        handleConfirm={() => handleConfirm()}
        handleCancel={() => handleCancel()}
      >
        <Input
          value={searchInput}
          type="text"
          placeholder="Pesquisar por Nome"
          onChange={({ target }) => setSearchInput(target.value)}
          onKeyPress={(e) => e.key === "Enter" && setFilters([searchInput])}
          className="search-input input-form"
        />
        <Spacer marginBottom={10} />
        <div style={{ width: "310px", height: "220px" }}>
          <ListCondoUsers smallList={true} filters={filters} />
        </div>
      </ModalComponent>
    </div>
  );
};

export default OpenDoorCard;
